import axios from "../plugins/axios";
import { ElMessage } from "element-plus";

/**
 * 重置配置删除
 * @param params
 * @returns {Promise<Awaited<unknown>>}
 */
export const rechargeConfigDelete = async (params) => {
    const res = await axios.post("/rechargeConfig/delete", params);
    if (res.data.code === 200) {
        ElMessage.success(res.data.msg);
        return Promise.resolve(res.data.id);
    } else {
        ElMessage.error(res.data.msg);
        return Promise.reject(res.data.msg);
    }
};
